import { createStorage } from '@aviata/storage';

import { AI_CHAT_ONBOARDING_STORAGE_KEY } from '../config';

const storage = createStorage(localStorage);

export const aiChatOnboardingState = {
  setAiChatOnboardingVisibility(value: boolean) {
    storage.stringify(AI_CHAT_ONBOARDING_STORAGE_KEY, value);
  },
  getAiChatOnboardingVisibility() {
    return storage.parse(AI_CHAT_ONBOARDING_STORAGE_KEY);
  },
};
